import {style, keyframes} from 'typestyle'
import * as csstips from 'csstips'

export const container = style({
    margin: '0 15px 15px 15px'
})

export const title = style({
    padding: '13px 0px',
    fontSize: 18,
    color: '#000000',
    textAlign: 'left',
    display: 'flex',
    ...csstips.flexRoot,
    ...csstips.betweenJustified
})

export const bold = style({
    fontWeight: 'bold'
})

export const right = style({
    fontSize: 14,
    color: '#999999',
    textAlign: 'right',
    display: 'flex',
    cursor: 'pointer',
    ...csstips.flexRoot,
    ...csstips.center
})

export const arrow = style({
    borderLeft: '2px solid #ccc',
    borderTop: '2px solid #ccc',
    display: 'inline-block',
    height: '8px',
    width: '8px',
    transform: 'rotate(135deg)'
})

export const list = style({
    display: 'flex',
    ...csstips.flexRoot,
    width: '100%'
})

export const listItem = style({
    width: '31%',
    marginRight: '3.3%',
    display: 'flex',
    cursor: 'pointer',
    ...csstips.flexRoot,
    ...csstips.centerJustified,
    ...csstips.vertical,
    ...csstips.content,
    ...csstips.center,
    boxShadow: '0 1px 3px 1px #F0F0F0',
    borderRadius: '6px',
    boxSizing: 'border-box',
    padding: '15px 10px',
    background: '#fff',
    textDecoration: 'none',
    $nest: {
        '&:active': {
            backgroundColor: '#f8f8f8'
        },
        '&:last-child': {
            marginRight: 0
        }
    }
})

export const avatar = style({
    height: 48,
    width: 48,
    position: 'relative'
})

export const icon = style({
    height: 16,
    width: 16,
    position: 'absolute',
    right: 0,
    bottom: 0
})

export const pic = style({
    height: '100%',
    width: '100%',
    borderRadius: '50%',
    userSelect: 'none'
})

export const name = style({
    fontSize: '14px',
    color: '#333333',
    textAlign: 'center',
    marginTop: '10px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%'
})

export const personNumb = style({
    fontSize: '12px',
    color: '#999999',
    textAlign: 'center',
    lineHeight: '16px',
    marginTop: '5px'
})

export const desc = style({
    fontSize: '14px',
    color: '#666666',
    letterSpacing: 0,
    textAlign: 'justify',
    lineHeight: '22px'
})



// WEBPACK FOOTER //
// ./src/views/SearchResult/components/LiveRoom/LiveRoom.style.ts